import { render, staticRenderFns } from "./PosProductGrid.vue?vue&type=template&id=66591e15&scoped=true"
import script from "./PosProductGrid.vue?vue&type=script&lang=js"
export * from "./PosProductGrid.vue?vue&type=script&lang=js"
import style0 from "./PosProductGrid.vue?vue&type=style&index=0&id=66591e15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66591e15",
  null
  
)

export default component.exports